// extracted by mini-css-extract-plugin
module.exports = {"float-marker":"+GlCk","rendered":"xoR31"};